<app-card-content [border]="false" [headerColor]="true" icon="pi pi-verified" title="Biometria" subtitle="Foto, assinatura e digitais">
    <div card-header>
        <app-botao-acoes [label]="'Ações'" [items]="acoesFormulario" [destaque]="itensEdicao" [destaqueAtivo]="isEditing" [appCan]="roleBiometriaEditar" [appCanUf]="pessoa()?.uf" [permissaoUf]="pessoa()?.uf ?? null" />
    </div>

    @if (isLoading()) {
        <div class="flex min-h-[300px] items-center justify-center p-6">
            <p-progressSpinner aria-label="A carregar dados" />
        </div>
    } @else {
        <div class="biometria-shell">
            <div class="biometria-container">
                @if (isEditing) {
                    <div class="flex items-center justify-end gap-4 mb-4">
                        @if (isEditing) {
                            <div class="flex items-center">
                                <div class="flex items-center gap-2 bg-gray-50 px-3 py-1 rounded border border-gray-200">
                                    <span class="text-sm font-semibold text-gray-700">Diretório da imagem:</span>
                                    <span class="text-sm font-mono text-gray-600 select-all">{{ diretorioImagens }}</span>
                                    <p-button icon="pi pi-copy" [text]="true" [rounded]="true" severity="secondary" styleClass="w-8 h-8" pTooltip="Copiar caminho" tooltipPosition="top" (onClick)="copiarDiretorio()"> </p-button>
                                </div>
                            </div>
                        }
                        <input #folderInput type="file" webkitdirectory multiple class="hidden" (change)="onFolderSelected($event)" />
                        @if (isEditing) {
                            <p-button label="Carregar Novas Imagens" icon="pi pi-upload" (onClick)="folderInput.click()" pTooltip="Selecione a pasta contendo os arquivos .wsq (ex: 1.wsq, 2.wsq...)"> </p-button>
                        }
                    </div>
                }

                <div class="section-wrapper mb-8 mt-4">
                    <div class="flex flex-col md:flex-row gap-6 items-stretch">
                        <div class="w-full md:w-1/3 lg:w-1/4 flex">
                            <app-card-container class="dedo-card foto-card w-full" [light]="false" [hoverEfect]="false">
                                <div class="dedo-card__header flex justify-between items-center">
                                    <label class="dedo-card__titulo"><i class="pi pi-camera" aria-hidden="true"></i> Fotografia</label>
                                    <span [class]="'bio-selo bio-selo--' + situacaoDaFoto()"><i [class]="iconeDaSituacao(situacaoDaFoto())" aria-hidden="true"></i>{{ rotuloDaSituacao(situacaoDaFoto()) }}</span>
                                </div>

                                <div class="dedo-card__imagem flex-col bio-imagem-foto">
                                    @if (state.fotoSrc) {
                                        <p-image [src]="state.fotoSrc" alt="Foto" class="h-full w-full object-contain" [preview]="true" [appendTo]="'body'" />
                                    } @else {
                                        <i class="pi pi-user text-gray-300 text-6xl"></i>
                                        <span class="text-xs text-gray-400 mt-2 font-medium">Sem fotografia</span>
                                    }
                                </div>

                                <!-- Divulgação à esquerda e data à direita, na mesma linha: são os dois dados
                                     que se lê sobre a foto sem abri-la. -->
                                <div class="dedo-card__footer bio-rodape">
                                    <div class="dedo-card__anomalia">
                                        <label for="divulgarFoto" class="text-sm font-medium">Divulgação</label>
                                        <app-switch-sim-nao inputId="divulgarFoto" [(ngModel)]="state.divulgarFoto" [desabilitado]="!isEditing" />
                                    </div>
                                    <span class="bio-atualizado">Atualizado: {{ state.datasImagens.foto || '--' }}</span>
                                </div>

                                @if (isEditing) {
                                    <div class="dedo-card__footer justify-end">
                                        <input #fotoInput type="file" accept="image/*" class="hidden" (change)="onFileSelected($event, 'F')" />
                                        <div class="dedo-card__acoes">
                                            <p-button icon="pi pi-upload" [text]="true" [rounded]="true" severity="secondary" (onClick)="fotoInput.click()" pTooltip="Carregar Foto"></p-button>
                                            @if (state.fotoSrc) {
                                                <p-button icon="pi pi-trash" [text]="true" [rounded]="true" severity="danger" (onClick)="removeImage('F')" pTooltip="Remover Foto" [appCan]="roleBiometriaExcluir" [appCanUf]="pessoa()?.uf"></p-button>
                                            }
                                        </div>
                                    </div>
                                }
                            </app-card-container>
                        </div>

                        <div class="w-full md:w-2/3 lg:w-3/4 flex">
                            <app-card-container class="dedo-card w-full" [light]="false" [hoverEfect]="false">
                                <div class="dedo-card__header flex justify-between items-center">
                                    <label class="dedo-card__titulo"><i class="pi pi-pencil" aria-hidden="true"></i> Assinatura</label>
                                    <span [class]="'bio-selo bio-selo--' + situacaoDaAssinatura()"><i [class]="iconeDaSituacao(situacaoDaAssinatura())" aria-hidden="true"></i>{{ rotuloDaSituacao(situacaoDaAssinatura()) }}</span>
                                </div>

                                <div class="dedo-card__imagem bio-imagem-assinatura">
                                    @if (state.assinaturaSrc) {
                                        <p-image [src]="state.assinaturaSrc" alt="Assinatura" [preview]="true" [appendTo]="'body'" imageClass="max-h-40 object-contain w-full" />
                                    } @else {
                                        <div class="flex flex-col items-center">
                                            <i class="pi pi-pencil text-gray-300 text-4xl mb-2"></i>
                                            <span class="text-xs text-gray-400 font-medium">Área de assinatura</span>
                                        </div>
                                    }
                                </div>

                                <div class="dedo-card__footer bio-rodape flex-col sm:flex-row items-start sm:items-center">
                                    <div class="dedo-card__anomalia">
                                        <p-checkbox [(ngModel)]="state.anomalias.assinatura" [binary]="true" inputId="anomaliaAssinatura" [disabled]="!isEditing"></p-checkbox>
                                        <label for="anomaliaAssinatura" class="text-sm font-medium">Anomalia</label>
                                    </div>
                                    <span class="bio-atualizado">Atualizado: {{ state.datasImagens.assinatura || '--' }}</span>

                                    @if (isEditing) {
                                        <div class="w-full sm:w-auto flex justify-end mt-2 sm:mt-0">
                                            <input #assinaturaInput type="file" accept="image/*" class="hidden" (change)="onFileSelected($event, 'A')" />
                                            <div class="dedo-card__acoes">
                                                <p-button icon="pi pi-upload" [text]="true" [rounded]="true" severity="secondary" (onClick)="assinaturaInput.click()" pTooltip="Carregar Assinatura"></p-button>
                                                @if (state.assinaturaSrc) {
                                                    <p-button
                                                        icon="pi pi-trash"
                                                        [text]="true"
                                                        [rounded]="true"
                                                        severity="danger"
                                                        (onClick)="removeImage('A')"
                                                        pTooltip="Remover Assinatura"
                                                        [appCan]="roleBiometriaExcluir"
                                                        [appCanUf]="pessoa()?.uf"
                                                    ></p-button>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                            </app-card-container>
                        </div>
                    </div>
                </div>
                <app-card-content [headerColor]="false" icon="pi pi-verified" title="Mão Direita">
                    <!-- Resumo da mão no cabeçalho: quantas digitais e quantas ressalvas, sem contar card a card. -->
                    <div card-header class="bio-resumo">
                        @let resumoDireita = resumoDeMao('direita');
                        <span class="bio-selo bio-selo--capturada"><i class="pi pi-check-circle" aria-hidden="true"></i>{{ resumoDireita.capturadas }} / {{ resumoDireita.total }} digitais</span>
                        <span [class]="resumoDireita.anomalias > 0 ? 'bio-selo bio-selo--anomalia' : 'bio-selo bio-selo--neutro'">
                            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>{{ resumoDireita.anomalias }} {{ resumoDireita.anomalias === 1 ? 'anomalia' : 'anomalias' }}
                        </span>
                    </div>
                    <div class="biometria-dedos-grid">
                        @for (dedo of dedosLista; track dedo; let i = $index) {
                            <app-card-container class="dedo-card" [light]="false" [hoverEfect]="false">
                                <div class="dedo-card__header bio-cabeca-dedo">
                                    <label class="dedo-card__titulo capitalize">{{ dedo }}</label>
                                    <span [class]="'bio-selo bio-selo--' + situacaoDoDedo('direita', i, dedo)"
                                        ><i [class]="iconeDaSituacao(situacaoDoDedo('direita', i, dedo))" aria-hidden="true"></i>{{ rotuloDaSituacao(situacaoDoDedo('direita', i, dedo)) }}</span
                                    >
                                    @if (state.motivoAnomalia.maoDireita[dedo]) {
                                        <div class="dedo-card__motivo" [title]="state.motivoAnomalia.maoDireita[dedo]">{{ state.motivoAnomalia.maoDireita[dedo] }}</div>
                                    }
                                </div>

                                <div class="dedo-card__imagem">
                                    @if (state.dedosSrc.direita[i]) {
                                        <p-image [src]="state.dedosSrc.direita[i]" [alt]="'Direita ' + dedo" class="object-contain flex-1" [imageStyle]="IMAGE_STYLE" [preview]="true" [appendTo]="'body'" />
                                        <span class="dedo-card__wsq-label">{{ rotuloArquivoOriginalWsq('direita', i) }}</span>
                                    } @else {
                                        <div class="flex flex-col items-center">
                                            <i class="pi pi-tag text-gray-300 text-4xl mb-2"></i>
                                            <span class="text-xs text-gray-400 font-medium">Sem Digital</span>
                                        </div>
                                    }
                                </div>

                                <div class="dedo-card__footer bio-rodape">
                                    <div class="dedo-card__anomalia">
                                        <p-checkbox [(ngModel)]="state.anomalias.maoDireita[dedo]" [binary]="true" [inputId]="'ad_' + dedo" [disabled]="!isEditing" (onChange)="onAnomaliaChanged('direita', dedo, i, $event.checked)"></p-checkbox>
                                        <label [for]="'ad_' + dedo" class="text-sm">Anomalia</label>
                                    </div>
                                    <span class="bio-atualizado">Atualizado:<br />{{ state.datasImagens.maoDireita[dedo] || '--' }}</span>

                                    @if (isEditing) {
                                        <input #dedoInput type="file" accept=".wsq" class="hidden" (change)="onFileSelected($event, 'D' + (i + 1))" />
                                        <!--
                                            Ações com rótulo, como no layout pedido. "Inserir", e não "Capturar":
                                            o botão abre um seletor de arquivo .wsq — não aciona leitor biométrico —,
                                            e prometer captura seria dizer o que a tela não faz.
                                        -->
                                        <div class="dedo-card__acoes bio-acoes">
                                            <p-button label="Inserir" icon="pi pi-upload" [text]="true" size="small" severity="secondary" (onClick)="dedoInput.click()" pTooltip="Inserir arquivo .wsq"></p-button>
                                            @if (state.dedosSrc.direita[i]) {
                                                <p-button
                                                    label="Remover"
                                                    icon="pi pi-trash"
                                                    [text]="true"
                                                    size="small"
                                                    severity="danger"
                                                    (onClick)="removeImage('D' + (i + 1))"
                                                    pTooltip="Remover Imagem"
                                                    [appCan]="roleBiometriaExcluir"
                                                    [appCanUf]="pessoa()?.uf"
                                                ></p-button>
                                            }
                                        </div>
                                    }
                                </div>
                            </app-card-container>
                        }
                    </div>
                </app-card-content>
                <app-card-content [headerColor]="false" icon="pi pi-verified" title="Mão Esquerda">
                    <!-- Resumo da mão no cabeçalho: quantas digitais e quantas ressalvas, sem contar card a card. -->
                    <div card-header class="bio-resumo">
                        @let resumoEsquerda = resumoDeMao('esquerda');
                        <span class="bio-selo bio-selo--capturada"><i class="pi pi-check-circle" aria-hidden="true"></i>{{ resumoEsquerda.capturadas }} / {{ resumoEsquerda.total }} digitais</span>
                        <span [class]="resumoEsquerda.anomalias > 0 ? 'bio-selo bio-selo--anomalia' : 'bio-selo bio-selo--neutro'">
                            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>{{ resumoEsquerda.anomalias }} {{ resumoEsquerda.anomalias === 1 ? 'anomalia' : 'anomalias' }}
                        </span>
                    </div>
                    <div class="biometria-dedos-grid">
                        @for (dedo of dedosLista; track dedo; let i = $index) {
                            <app-card-container class="dedo-card" [light]="false" [hoverEfect]="false">
                                <div class="dedo-card__header bio-cabeca-dedo">
                                    <label class="dedo-card__titulo capitalize">{{ dedo }}</label>
                                    <span [class]="'bio-selo bio-selo--' + situacaoDoDedo('esquerda', i, dedo)"
                                        ><i [class]="iconeDaSituacao(situacaoDoDedo('esquerda', i, dedo))" aria-hidden="true"></i>{{ rotuloDaSituacao(situacaoDoDedo('esquerda', i, dedo)) }}</span
                                    >
                                    @if (state.motivoAnomalia.maoEsquerda[dedo]) {
                                        <div class="dedo-card__motivo" [title]="state.motivoAnomalia.maoEsquerda[dedo]">{{ state.motivoAnomalia.maoEsquerda[dedo] }}</div>
                                    }
                                </div>

                                <div class="dedo-card__imagem">
                                    @if (state.dedosSrc.esquerda[i]) {
                                        <p-image [src]="state.dedosSrc.esquerda[i]" [alt]="'Esquerda ' + dedo" class="object-contain flex-1" [imageStyle]="IMAGE_STYLE" [preview]="true" [appendTo]="'body'" />
                                        <span class="dedo-card__wsq-label">{{ rotuloArquivoOriginalWsq('esquerda', i) }}</span>
                                    } @else {
                                        <div class="flex flex-col items-center">
                                            <i class="pi pi-tag text-gray-300 text-4xl mb-2"></i>
                                            <span class="text-xs text-gray-400 font-medium">Sem Digital</span>
                                        </div>
                                    }
                                </div>

                                <div class="dedo-card__footer bio-rodape">
                                    <div class="dedo-card__anomalia">
                                        <p-checkbox [(ngModel)]="state.anomalias.maoEsquerda[dedo]" [binary]="true" [inputId]="'ae_' + dedo" [disabled]="!isEditing" (onChange)="onAnomaliaChanged('esquerda', dedo, i, $event.checked)"></p-checkbox>
                                        <label [for]="'ae_' + dedo" class="text-sm">Anomalia</label>
                                    </div>
                                    <span class="bio-atualizado">Atualizado:<br />{{ state.datasImagens.maoEsquerda[dedo] || '--' }}</span>

                                    @if (isEditing) {
                                        <input #dedoEsqInput type="file" accept=".wsq" class="hidden" (change)="onFileSelected($event, 'D' + (i + 6))" />
                                        <!--
                                            Ações com rótulo, como no layout pedido. "Inserir", e não "Capturar":
                                            o botão abre um seletor de arquivo .wsq — não aciona leitor biométrico —,
                                            e prometer captura seria dizer o que a tela não faz.
                                        -->
                                        <div class="dedo-card__acoes bio-acoes">
                                            <p-button label="Inserir" icon="pi pi-upload" [text]="true" size="small" severity="secondary" (onClick)="dedoEsqInput.click()" pTooltip="Inserir arquivo .wsq"></p-button>
                                            @if (state.dedosSrc.esquerda[i]) {
                                                <p-button
                                                    label="Remover"
                                                    icon="pi pi-trash"
                                                    [text]="true"
                                                    size="small"
                                                    severity="danger"
                                                    (onClick)="removeImage('D' + (i + 6))"
                                                    pTooltip="Remover Imagem"
                                                    [appCan]="roleBiometriaExcluir"
                                                    [appCanUf]="pessoa()?.uf"
                                                ></p-button>
                                            }
                                        </div>
                                    }
                                </div>
                            </app-card-container>
                        }
                    </div>
                </app-card-content>
                <!--
                    Legenda das cores, uma vez para o formulário todo. Sem ela, o selo verde e o
                    âmbar dependem de o leitor deduzir o que significam — e o cinza, de perceber que
                    existe.
                -->
                <div class="bio-legenda">
                    <span class="bio-legenda-item"><i class="pi pi-check-circle bio-legenda-icone bio-legenda-icone--capturada" aria-hidden="true"></i>Capturada</span>
                    <span class="bio-legenda-item"><i class="pi pi-exclamation-triangle bio-legenda-icone bio-legenda-icone--anomalia" aria-hidden="true"></i>Anomalia</span>
                    <span class="bio-legenda-item"><i class="pi pi-circle bio-legenda-icone bio-legenda-icone--ausente" aria-hidden="true"></i>Não capturada</span>
                    <span class="bio-legenda-dica"><i class="pi pi-info-circle" aria-hidden="true"></i>Clique na imagem para ampliar</span>
                </div>

                <app-card-content [headerColor]="false" icon="pi pi-folder-open" title="Documentos Comprobatórios">
                    <div card-header>
                        @if (isEditing) {
                            <span [pTooltip]="exclusaoDocumentoPendente ? 'Salve as alterações antes de inserir um novo documento.' : ''" tooltipPosition="top">
                                <p-button label="Novo Documento" icon="pi pi-plus" size="small" (onClick)="abrirDialogNovoDocumento()" [disabled]="exclusaoDocumentoPendente" />
                            </span>
                        }
                    </div>
                    <p-table [value]="documentos" styleClass="p-datatable-sm w-full" [tableStyle]="{ width: '100%' }">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Inclusão</th>
                                <th>Descrição</th>
                                @if (isEditing) {
                                    <th style="width: 5rem">Ações</th>
                                }
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-row let-i="rowIndex">
                            <tr>
                                <td>{{ row.dataInclusao }}</td>
                                <td>
                                    <i [ngClass]="row.mimeType === 'application/pdf' ? 'pi pi-file-pdf text-red-600 mr-2' : 'pi pi-image text-blue-600 mr-2'"></i>
                                    <a class="underline cursor-pointer text-primary hover:text-primary-700" (click)="visualizarDocumento(row)">{{ row.nome }}</a>
                                </td>
                                @if (isEditing) {
                                    <td class="text-center">
                                        <p-button icon="pi pi-trash" severity="danger" [text]="true" [rounded]="true" (onClick)="removerDocumento(i)" [appCan]="roleBiometriaExcluir" [appCanUf]="pessoa()?.uf"></p-button>
                                    </td>
                                }
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td [attr.colspan]="isEditing ? 3 : 2" class="text-center">
                                    <div class="table-empty-state">
                                        <span class="table-empty-state-icon"><i class="pi pi-search"></i></span>
                                        <p class="table-empty-state-title">Nenhum documento comprobatório encontrado.</p>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </app-card-content>
                <p-dialog appDialogoPadrao="pi pi-file" descricao="Anexe um documento ao registro biométrico." header="Novo Documento" [(visible)]="showDocumentoDialog" [style]="{ width: '30rem' }" (onHide)="fecharDialogNovoDocumento()">
                    <div class="flex flex-col gap-4 pt-2">
                        <div class="flex flex-col gap-2">
                            <label for="docNome" class="font-semibold">Descrição/Nome</label>
                            <p-select
                                id="docNome"
                                class="w-full"
                                [style]="{ width: '100%' }"
                                [options]="documentoDescricaoOptions"
                                optionLabel="label"
                                optionValue="value"
                                [(ngModel)]="novoDocumentoNome"
                                appendTo="body"
                                placeholder="Selecione a descrição"
                            >
                            </p-select>
                        </div>
                        <div class="flex flex-col gap-2">
                            <label class="font-semibold">Arquivo</label>
                            <input
                                type="file"
                                (change)="onNovoDocumentoFileSelected($event)"
                                accept="image/*,.pdf"
                                class="w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-primary-50 file:text-primary-700 hover:file:bg-primary-100"
                            />
                        </div>
                    </div>
                    <ng-template pTemplate="footer">
                        <div class="flex justify-end gap-2">
                            <p-button label="Cancelar" severity="secondary" (onClick)="fecharDialogNovoDocumento()"></p-button>
                            <p-button label="Adicionar" icon="pi pi-check" (onClick)="adicionarNovoDocumentoLista()" [disabled]="!novoDocumentoNome || !novoDocumentoFile"></p-button>
                        </div>
                    </ng-template>
                </p-dialog>
                <p-dialog appDialogoPadrao="pi pi-paperclip" descricao="Documento anexado ao registro." [(visible)]="exibirDialogAnexo" [style]="{ width: '90vw', maxWidth: '1200px' }" header="Visualização de anexo" (onHide)="fecharDialogAnexo()">
                    @if (blobAnexo) {
                        <app-visualizador-pdf [src]="blobAnexo" [fileName]="nomeArquivoAnexo" [showAll]="false"></app-visualizador-pdf>
                    } @else if (dataUrlAnexo) {
                        <app-card-content [headerColor]="false" icon="pi pi-eye" title="Visualização do Anexo">
                            <div card-header class="flex items-center gap-2">
                                <p-button icon="pi pi-search-minus" type="button" (click)="diminuirZoomImagemAnexo()" [disabled]="zoomImagemAnexo <= 0.5" />
                                <span class="text-sm font-medium w-16 text-center"> {{ zoomImagemAnexo * 100 | number: '1.0-0' }}% </span>
                                <p-button icon="pi pi-search-plus" type="button" (click)="aumentarZoomImagemAnexo()" [disabled]="zoomImagemAnexo >= 2" />
                                <p-button label="Download" icon="pi pi-download" type="button" (click)="downloadAnexoImagem()" />
                            </div>
                            <div class="biometria-anexo-imagem">
                                <img [src]="dataUrlAnexo" [alt]="nomeArquivoAnexo" [style.transform]="'scale(' + zoomImagemAnexo + ')'" />
                            </div>
                        </app-card-content>
                    } @else {
                        <div class="text-center text-color-secondary italic p-4">Nenhum anexo disponível para visualização.</div>
                    }
                </p-dialog>
                <app-anomalia-motivo-dialog [(showDialog)]="showMotivoDialog" [valorAtual]="motivoDialogValorAtual" (escolhido)="onMotivoEscolhido($event)" (cancelado)="onMotivoCancelado()"> </app-anomalia-motivo-dialog>
            </div>
        </div>
    }
</app-card-content>
